import styled from '@emotion/styled'

export const ProductCard = styled.div`
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;

  width: calc(100% - 1rem);
  max-height: 3rem; /* ringkas, compact */
  background: rgba(255, 255, 255, 0.8);

  display: flex;
  align-items: center;
  gap: 0.6rem;

  border-radius: 10px;
  padding: 0.5rem 0.7rem;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.12);
    background: rgba(255, 255, 255, 1);
  }
`

export const ProductImage = styled.img`
  width: 1.5rem; /* kecil */
  height: 1.5rem;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ProductName = styled.p`
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;

  /* anti layout shift */
  min-width: 0;
  flex: 1;
`

export const Arrow = styled.span`
  font-size: 1rem;
  color: #666;
  flex-shrink: 0;
`
export const Badge = styled.div`
  position: absolute;
  top: -0.5rem;
  left: 0;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  padding: 2px 6px;
  font-size: 0.6rem;
  border-radius: 4px;
  backdrop-filter: blur(4px);
`
